import { Link } from 'react-router-dom';

const Footer = () => {
  const footerLinks = [
    {
      title: '關於我們',
      links: ['中心介紹', '服務理念', '專業團隊'],
    },
    {
      title: '服務項目',
      links: ['長照3.0', '失智照護', '失能照護', '生活照顧'],
    },
    {
      title: '服務區域',
      links: ['前金區', '新興區', '苓雅區', '鹽埕區', '三民區', '鼓山區'],
    },
  ];

  const scrollToSection = (section: string) => {
    const sectionMap: Record<string, string> = {
      '中心介紹': '#about',
      '服務理念': '#about',
      '專業團隊': '#about',
      '長照3.0': '#services',
      '失智照護': '#services',
      '失能照護': '#services',
      '生活照顧': '#activities',
      '交通資訊': '#transport',
    };
    const target = sectionMap[section];
    if (target) {
      document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const isServiceArea = (link: string) => {
    return ['前金區', '新興區', '苓雅區', '鹽埕區', '三民區', '鼓山區'].includes(link);
  };

  return (
    <footer className="bg-cream-100 pt-16 pb-8" role="contentinfo">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/d5aea6c2e30695f7c421b6c6d03bc7cc.png" 
                alt="前金日間照顧中心 Logo" 
                title="高雄市前金區日照中心"
                className="w-10 h-10 object-contain"
              />
              <span className="font-bold text-baby-blue-600">前金日間照顧中心</span>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed">
              <strong>高雄市前金區日照中心</strong>用心照護每一位長者，讓愛延續，給家屬安心的選擇。<strong>高雄市前金日照推薦</strong>首選。
            </p>
            <address className="not-italic text-sm text-gray-500 mt-3">
              <p>地址：高雄市前金區文武二街163號5樓</p>
              <p>電話：<a href="tel:07-2416568" className="hover:text-baby-blue-500 transition-colors">07-2416568</a></p>
            </address>
            <div className="flex gap-3 mt-4">
              <a 
                href="https://www.facebook.com/p/前金社區日間照顧機構-100063908289224/" 
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center bg-baby-blue-200 hover:bg-baby-blue-300 rounded-full transition-colors cursor-pointer" 
                aria-label="前金日照中心 Facebook 粉絲專頁"
              >
                <i className="ri-facebook-fill text-baby-blue-600" aria-hidden="true"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-baby-blue-200 hover:bg-baby-blue-300 rounded-full transition-colors cursor-pointer" aria-label="前金日照中心 LINE 官方帳號" rel="nofollow">
                <i className="ri-line-fill text-baby-blue-600" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group, index) => (
            <nav key={index} aria-label={group.title}>
              <h4 className="font-bold text-baby-blue-600 mb-4">
                {index === 2 ? (
                  <Link to="/service-area" className="hover:text-baby-blue-700 transition-colors">
                    {group.title}
                  </Link>
                ) : (
                  <a href={index === 0 ? '#about' : '#services'} className="hover:text-baby-blue-700 transition-colors">
                    {group.title}
                  </a>
                )}
              </h4>
              <ul className="space-y-2">
                {group.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {isServiceArea(link) ? (
                      <Link
                        to="/service-area"
                        className="text-sm text-gray-500 hover:text-baby-blue-500 transition-colors cursor-pointer"
                      >
                        {link}
                      </Link>
                    ) : (
                      <a
                        href="#"
                        onClick={(e) => { e.preventDefault(); scrollToSection(link); }}
                        className="text-sm text-gray-500 hover:text-baby-blue-500 transition-colors cursor-pointer"
                      >
                        {link}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="border-t border-cream-300 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-sm text-gray-500">
              © 2025 <strong>前金日間照顧中心</strong> - 高雄市前金區日照中心 版權所有
            </div>
            <div className="flex items-center gap-4">
              <Link to="/admin/login" className="text-sm text-gray-400 hover:text-baby-blue-500 transition-colors cursor-pointer flex items-center gap-1">
                <i className="ri-lock-line" aria-hidden="true"></i>
                管理員登入
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
